import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import superstyled from '@zenbusiness/zui/styles/superstyled';

import { BASE_STYLES } from '../utils/constants';

export const ButtonPromptContainer = superstyled({
  name: 'ButtonContainer',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    display: 'flex',
    justifyContent: 'flex-end'
  })
});

export const ButtonPromptInner = superstyled({
  name: 'ButtonPromptInner',
  slot: 'Inner',
  tag: Box,
  styles: () => ({
    maxWidth: '85%'
  })
});

export const StyledButton = superstyled({
  name: 'Button',
  slot: 'Root',
  tag: Button,
  styles: ({ theme, appearance }) => {
    const BUTTON_STYLES = {
      textAlign: 'right',
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5, 2),
      fontSize: '0.875rem',
      lineHeight: '1.25'
    };
    // Primary appearance: colorful gradient border (current behavior)
    if (appearance === 'primary') {
      return {
        ...BUTTON_STYLES,
        ...BASE_STYLES,
        '&:hover': {
          background: theme.palette.background.grey.alpha.light,
          border: `1px solid ${theme.palette.border.main}`,
          boxShadow: 'none',
          scale: 0.98
        }
      };
    }

    // Secondary appearance: light gray border
    if (appearance === 'secondary') {
      return {
        ...BUTTON_STYLES,
        ...BASE_STYLES,
        background: '#fff',
        border: '1px solid var(--Border-Main, rgba(0, 0, 0, 0.10))',
        '&:hover': {
          borderRadius: theme.shape.borderRadius,
          background: theme.palette.background.grey.alpha.light, // 'var(--Background-Grey-Alpha-Light, rgba(0, 0, 0, 0.02))',
          border: `1px solid ${theme.palette.border.main}`, // `1px solid ${theme.palette.border.main}`,//'1px solid var(--Border-Main, rgba(0, 0, 0, 0.10))',
          boxShadow: 'none',
          scale: 0.98
        }
      };
    }

    // Fallback to primary if appearance is not recognized
    return {
      ...BUTTON_STYLES,
      ...BASE_STYLES,
      '&:hover': {
        borderRadius: theme.shape.borderRadius,
        background: theme.palette.background.grey.alpha.light, // 'var(--Background-Grey-Alpha-Light, rgba(0, 0, 0, 0.02))',
        border: `1px solid ${theme.palette.border.main}`, // '1px solid var(--Border-Main, rgba(0, 0, 0, 0.10))',
        boxShadow: 'none',
        scale: 0.98
      }
    };
  }
});
